<template>
<b-container>
    <div class="sdsd">
        <b-colxx xxs="12">
            <b-card class="mb-4">
                <piaf-breadcrumb :heading="$t('menu.booking-call-reservation')" />
                <div class="separator mb-5"></div>
                <div v-if="!pageFlag">
                    <b-row>
                        <b-colxx xxs="12">
                            <b-row>
                                <b-col md="auto" class="mb-2">
                                    <div class="has-float-label">
                                        <b-input-group class="mb-3">
                                            <b-input placeholder="조회하실 번호를 입력하세요" @keypress.native.enter="getPhoneNumberInfo" style="width: 300px;" v-model="inputPh" />
                                            <b-button variant="outline-primary default" size="lg" @click="getPhoneNumberInfo">조회</b-button>
                                        </b-input-group>
                                        <span>전화번호</span>
                                    </div>
                                </b-col>
                                <b-colxx class="text-right">
                                    <b-button variant="primary" size="lg" class="top-right-button" @click="createBooking">신규예약접수</b-button>
                                </b-colxx>
                            </b-row>
                        </b-colxx>
                    </b-row>
                    <b-colxx xxs="12" v-if="!searchHistory">
                        <div class="imgMagnifier">
                            <b-row align-v="center" align-h="center" no-gutters>
                                <i class="simple-icon-magnifier" style="color: lightgrey; font-size: 150px;"></i>
                            </b-row>
                            <b-row align-v="center" align-h="center" no-gutters class="mt-4">
                                <a style="color: lightgrey; font-size: 25px;">전화번호를 입력하시면 고객현황을</a>
                            </b-row>
                            <b-row align-v="center" align-h="center" no-gutters class="mb-5">
                                <a style="color: lightgrey; font-size: 25px;">확인하실 수 있습니다.</a>
                            </b-row>
                        </div>
                    </b-colxx>
                    <b-colxx xxs="12" v-if="searchHistory">
                        <div v-if="searchName =='NULL' || searchName =='null' || searchName =='undefinded' || searchName ==''  ">
                        </div>
                        <div v-else>
                            <b-row>
                                <a style="font-size: 28px; color: #c11314">{{searchPhoneNumber.replace(/^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?([0-9]{3,4})-?([0-9]{4})$/, "$1-$2-$3")}}</a> <a style="padding-top: 10px; padding-left: 10px; font-size: 17px;">({{searchName}})님의 고객 정보입니다.</a>
                            </b-row>
                        </div>
                        <br>
                        <b-row>
                            <b-col cols="2">
                                <b-form-group>
                                    <b-form-row style="padding-top: 60px;">
                                        <span class="vitext">최근 한달 방문횟수<br><a class="vitextA" style="color: #c11314">{{visitCountFor1Month}}</a></span>
                                    </b-form-row>
                                    <b-form-row style="padding-top: 60px;">
                                        <span class="vitext">총 방문횟수<br><a class="vitextA" style="color: #c11314">{{totalVisitCount}}</a></span>
                                    </b-form-row>
                                    <b-form-row style="padding-top: 60px;">
                                        <span class="vitext">취소<br><a class="vitextA" style="color: #c11314">{{totalCancelCount}}</a></span>
                                    </b-form-row>
                                    <b-form-row style="padding-top: 60px;">
                                        <span class="vitext">No-Show<br><a class="vitextA" style="color: #c11314">{{totalNoShowCount}}</a></span>
                                    </b-form-row>
                                </b-form-group>
                            </b-col>

                            <span class="vertical-line"></span>

                            <b-col cols="9">
                                <b-form-group>
                                    <b-form-row style="padding-top: 20px; padding-left: 10px">
                                        <span style="font-size: 17px; padding-left: 30px;">방문내역</span><br>
                                    </b-form-row>
                                    <b-table style="padding-top: 20px; padding-left: 30px;" v-if="currentUser.userRole == 'STORE_MANAGER'" :tbody-tr-class="rowClass" :items="searchHistoryList" :fields="historyFieldsStr" head-variant="dark" ref="general-table" class="vuetable toolpoios" id="table-transition-example" align="center" primary-key="bookingNo" empty-text="내역이 없습니다." responsive show-empty>
                                        <template v-slot:cell(reservationTime)="row">
                                            {{ row.item.reservationTime.substr(0,5) }}
                                        </template>
                                        <template v-slot:cell(headcount)="row">
                                            {{Number(row.item.adultHeadcount) + Number(row.item.childHeadcount) + Number(row.item.babyHeadcount)+'명' }}
                                        </template>

                                        <template v-slot:cell(visitorRequests)="row">
                                            <span class="textgreen" v-b-tooltip.hover.top tabindex="0" :title=row.item.visitorRequests v-if="row.item.visitorRequests != null">보기</span>
                                        </template>

                                        <template v-slot:cell(bookingStatus)="row">
                                            {{row.item.bookingStatus == "BookingRequested" ? "예약신청" : row.item.bookingStatus == "BookingRejected" ? "예약불가" : row.item.bookingStatus == "Booked" ? "예약완료" : row.item.bookingStatus == "CancelRequested" ? "예약취소신청" : row.item.bookingStatus == "Cancelled" ? "예약취소" : row.item.bookingStatus == "Visited" ? "방문완료" : "null"}}
                                            {{row.item.noShow == true ? "(노쇼)" : ''}}
                                        </template>

                                        <template v-slot:cell(button)="row">
                                            <b-button v-if="row.item.changeable" @click="updateListBooking(row.item)" variant="primary" style="border-color: white; background-color: white"><i class="simple-icon-pencil" style="color: darkblue; font-size: 18px;"></i></b-button>
                                            <b-button v-if="row.item.cancellable" @click="deleteListBooking(row.item.bookingNo)" variant="primary" style="border-color: white; background-color: white"><i class="simple-icon-trash" style="color: red; font-size: 18px;" /></b-button>
                                        </template>

                                    </b-table>

                                    <b-table style="padding-top: 20px; padding-left: 30px;" v-if="currentUser.userRole == 'BRAND_ADMIN'" :tbody-tr-class="rowClass" :items="searchHistoryList" :fields="historyFields" head-variant="dark" ref="general-table" class="vuetable" id="table-transition-example" align="center" primary-key="bookingNo" empty-text="내역이 없습니다." responsive show-empty>
                                        <template v-slot:cell(headcount)="row">
                                            {{Number(row.item.adultHeadcount) + Number(row.item.childHeadcount) + Number(row.item.babyHeadcount)+'명' }}
                                        </template>

                                        <template v-slot:cell(visitorRequests)="row">
                                            <span class="textgreen" v-b-tooltip.hover :title=row.item.visitorRequests v-if="row.item.visitorRequests != null">보기</span>
                                        </template>

                                        <template v-slot:cell(reservationTime)="row">
                                            {{ row.item.reservationTime.substr(0,5) }}
                                        </template>
                                        <template v-slot:cell(bookingStatus)="row">
                                            {{row.item.bookingStatus == "BookingRequested" ? "예약신청" : row.item.bookingStatus == "BookingRejected" ? "예약불가" : row.item.bookingStatus == "Booked" ? "예약완료" : row.item.bookingStatus == "CancelRequested" ? "예약취소신청" : row.item.bookingStatus == "Cancelled" ? "예약취소" : row.item.bookingStatus == "Visited" ? "방문완료" : "null"}}
                                            {{row.item.noShow == true ? "(노쇼)" : ''}}
                                        </template>

                                        <template v-slot:cell(button)="row">
                                            <b-button v-if="row.item.changeable" @click="updateListBooking(row.item)" variant="primary" style="border-color: white; background-color: white"><i class="simple-icon-pencil" style="color: darkblue; font-size: 18px;"></i></b-button>
                                            <!--                    <b-button v-if="row.item.cancellable" @click="deleteListBooking(row.item.bookingNo)" variant="primary" style="border-color: white; background-color: white"><i class="simple-icon-trash" style="color: red; font-size: 18px;"/></b-button>-->
                                            <b-button v-if="row.item.cancellable" @click="deleteListBooking(row.item.bookingNo)" variant="empty" style="padding-top: 10px;">
                                                <b-icon icon="trash" font-scale="1.8"></b-icon>
                                            </b-button>

                                        </template>

                                    </b-table>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-colxx>
                </div>
                <b-row v-if="pageFlag">
                    <b-col cols="6">

                        <b-form-group label-cols="0" horizontal label="" v-if="currentUser.userRole == 'BRAND_ADMIN'" >
                            <b-form-row>
                                <div class="form-group has-float-label col-12">
                                    <v-select :options="storeList" v-model="bookingInfo.selectedStore" label="label" :reduce="item=>item.value" style="width:100%"></v-select>
                                    <span>매장선택</span>
                                </div>
                            </b-form-row>
                        </b-form-group>

                        <b-form-group label-cols="0" v-if="bookingInfo.selectedStore != null && bookingInfo.selectedStore != ''">
                            <b-form-row>
                                <v-date-picker :show-day-popover="false"  v-model="bookingInfo.reservationDate" is-inline @input="bookingInventory" @update:fromPage="pageChange" :min-date="minDates" :disabled-dates="disableDates" is-expanded is-required />
                            </b-form-row>
                        </b-form-group>

                        <b-form-group label-cols="0">
                            <div class="form-group has-float-label">
                                <v-select :options="item" v-model="inventoryItem" label="showBookingTime" @change="selectTime" style="width: 100%">
                                    <span slot="no-options">방문할 날짜를 먼저 선택해 주세요</span>
                                    <template #option="{ bookingTime, availableInventory}">
                                        <h3>{{bookingTime.substr(0,5)}}</h3>
                                        <em style="padding-left: 10px;">잔여 : {{availableInventory}}</em>
                                    </template>
                                </v-select>
                                <span>예약시간선택</span>
                            </div>
                        </b-form-group>

                        <b-form-group label-cols="1" v-if="inventoryItem != null && inventoryItem != ''">
                            방문시간을 10분 단위로 접수 하시겠습니까? <a @click="getMinList" style="cursor:pointer; color:red; text-decoration: underline">바로가기</a>
                        </b-form-group>

                        <b-form-group label-cols="1" v-if="minFlag == true && mintag == false && inventoryItem != null">
                            <b-form-row>
                                <b-button variant="outline-danger" class="mr-3 test mt-2" :class="{active: bookingInfo.reservationTime == inventoryItem.bookingTime.substr(0,3) + '10:00' ? true : false}" @click="onClickTime(inventoryItem.bookingTime.substr(0,3) + '10:00',$event)"> {{
                    inventoryItem.bookingTime.substr(0,3)
                  }}10 (잔여 : {{ inventoryItem.availableInventory }} )
                                </b-button>
                                <b-button variant="outline-danger" class="mr-3 test mt-2" :class="{active: bookingInfo.reservationTime == inventoryItem.bookingTime.substr(0,3) + '20:00' ? true : false}" @click="onClickTime(inventoryItem.bookingTime.substr(0,3) + '20:00',$event)"> {{
                    inventoryItem.bookingTime.substr(0,3)
                  }}20 (잔여 : {{ inventoryItem.availableInventory }} )
                                </b-button>
                                <b-button variant="outline-danger" class="mr-3 test mt-2" :class="{active: bookingInfo.reservationTime == inventoryItem.bookingTime.substr(0,3) + '30:00' ? true : false}" @click="onClickTime(inventoryItem.bookingTime.substr(0,3) + '30:00',$event)"> {{
                    inventoryItem.bookingTime.substr(0,3)
                  }}30 (잔여 : {{ inventoryItem.availableInventory }} )
                                </b-button>
                            </b-form-row>
                            <b-form-row class="mt-2">
                                <b-button variant="outline-danger" class="mr-3 test" :class="{active: bookingInfo.reservationTime == inventoryItem.bookingTime.substr(0,3) + '40:00' ? true : false}" @click="onClickTime(inventoryItem.bookingTime.substr(0,3) + '40:00',$event)"> {{
                    inventoryItem.bookingTime.substr(0,3)
                  }}40 (잔여 : {{ inventoryItem.availableInventory }} )
                                </b-button>
                                <b-button variant="outline-danger" class="mr-3 test" :class="{active: bookingInfo.reservationTime == inventoryItem.bookingTime.substr(0,3) + '50:00' ? true : false}" @click="onClickTime(inventoryItem.bookingTime.substr(0,3) + '50:00',$event)"> {{
                    inventoryItem.bookingTime.substr(0,3)
                  }}50 (잔여 : {{ inventoryItem.availableInventory }} )
                                </b-button>
                            </b-form-row>
                        </b-form-group>

                        <b-form-group label-cols="1" v-if="minFlag == true && mintag == true && inventoryItem != null">
                            <b-form-row v-if="!minDetailTag">
                                <!--                <b-button variant="outline-danger" class="mr-3 test"-->
                                <!--                          @click="onClickTime(inventoryItem.bookingTime.substr(0,3) + '00:00',$event)"> {{-->
                                <!--                    inventoryItem.bookingTime.substr(0,3)-->
                                <!--                  }}00 (잔여 : {{ inventoryItem.availableInventory }} )-->
                                <!--                </b-button>-->
                                <b-button variant="outline-danger" class="mr-3 test" :class="{active: bookingInfo.reservationTime == inventoryItem.bookingTime.substr(0,3) + '10:00' ? true : false}" @click="onClickTime(inventoryItem.bookingTime.substr(0,3) + '10:00',$event)"> {{
                    inventoryItem.bookingTime.substr(0,3)
                  }}10 (잔여 : {{ inventoryItem.availableInventory }} )
                                </b-button>
                                <b-button variant="outline-danger" class="mr-3 test" :class="{active: bookingInfo.reservationTime == inventoryItem.bookingTime.substr(0,3) + '20:00' ? true : false}" @click="onClickTime(inventoryItem.bookingTime.substr(0,3) + '20:00',$event)"> {{
                    inventoryItem.bookingTime.substr(0,3)
                  }}20 (잔여 : {{ inventoryItem.availableInventory }} )
                                </b-button>
                            </b-form-row>
                            <b-form-row style="padding-top: 10px;" v-if="minDetailTag">
                                <!--                <b-button variant="outline-danger" class="mr-3 test"-->
                                <!--                          @click="onClickTime(inventoryItem.bookingTime.substr(0,3) + '30:00',$event)"> {{-->
                                <!--                    inventoryItem.bookingTime.substr(0,3)-->
                                <!--                  }}30 (잔여 : {{ inventoryItem.availableInventory }} )-->
                                <!--                </b-button>-->
                                <b-button variant="outline-danger" class="mr-3 test" :class="{active: bookingInfo.reservationTime == inventoryItem.bookingTime.substr(0,3) + '40:00' ? true : false}" @click="onClickTime(inventoryItem.bookingTime.substr(0,3) + '40:00',$event)"> {{
                    inventoryItem.bookingTime.substr(0,3)
                  }}40 (잔여 : {{ inventoryItem.availableInventory }} )
                                </b-button>
                                <b-button variant="outline-danger" class="mr-3 test" :class="{active: bookingInfo.reservationTime == inventoryItem.bookingTime.substr(0,3) + '50:00' ? true : false}" @click="onClickTime(inventoryItem.bookingTime.substr(0,3) + '50:00',$event)"> {{
                    inventoryItem.bookingTime.substr(0,3)
                  }}50 (잔여 : {{ inventoryItem.availableInventory }} )
                                </b-button>
                            </b-form-row>
                        </b-form-group>

                    </b-col>
                    <b-col cols="6">
                        <!--            <b-form-group label-cols="2" horizontal label="방문인원">-->
                        <!--              <b-row class="justify-content-start m-1" no-gutters>-->
                        <!--                <div class="form-group has-float-label">-->
                        <!--                  <input type="number" v-model="bookingInfo.adultCount" @change="checkHeadCount"-->
                        <!--                         style="width: 80px; height: 40px; text-align: center"/> 명-->
                        <!--                  <span>성인</span>-->
                        <!--                </div>-->

                        <!--                <div class="form-group has-float-label" style="padding-left: 30px;">-->
                        <!--                  <input type="number" v-model="bookingInfo.childCount" @change="checkHeadCount"-->
                        <!--                         style="width: 80px; height: 40px; text-align: center"/> 명-->
                        <!--                  <span style="padding-left: 30px;">소인</span>-->
                        <!--                </div>-->

                        <!--                <div class="form-group has-float-label" style="padding-left: 30px;">-->
                        <!--                  <input type="number" v-model="bookingInfo.babyCount"-->
                        <!--                         style="width: 80px; height: 40px; text-align: center"/> 명-->
                        <!--                  <span style="padding-left: 30px;">유아</span>-->
                        <!--                </div>-->

                        <!--              </b-row>-->
                        <!--            </b-form-group>-->
                        <b-form-group label-cols="2" horizontal label="방문인원">
                            <b-row>
                                <div class="form-group has-float-label" style="padding-left: 15px;">
                                    성인 <b-dropdown left align :text="bookingInfo.adultCount.toString()" variant="outline-primary" size="md">
                                        <div class="d-inline-block">
                                            <b-dropdown-item v-for="(size,index) in test1" :key="index" @click="checkAdultHeadCount(size)">
                                                {{ size }}
                                            </b-dropdown-item>
                                        </div>
                                    </b-dropdown>
                                </div>
                                <div class="form-group has-float-label" style="padding-left: 25px;">
                                    소인 <b-dropdown left align :text="bookingInfo.childCount.toString()" variant="outline-primary" size="md">
                                        <div class="d-inline-block">
                                            <b-dropdown-item v-for="(size,index) in test1" :key="index" @click="checkChildHeadCount(size)">
                                                {{ size }}
                                            </b-dropdown-item>
                                        </div>
                                    </b-dropdown>
                                </div>
                                <div class="form-group has-float-label" style="padding-left: 25px;">

                                    유아 <b-dropdown left align :text="bookingInfo.babyCount.toString()" variant="outline-primary" size="md">
                                        <div class="d-inline-block">
                                            <b-dropdown-item v-for="(size,index) in test1" :key="index" @click="checkBabyHeadCount(size)">
                                                {{ size }}
                                            </b-dropdown-item>
                                        </div>
                                    </b-dropdown>
                                </div>
                            </b-row>
                        </b-form-group>

                        <b-form-group label-cols="2" horizontal label="예약자명">
                            <b-form-row>
                                <b-form-input style="width: 400px;" v-model="bookingInfo.guestName">

                                </b-form-input>

                            </b-form-row>
                        </b-form-group>

                        <b-form-group label-cols="2" horizontal label="전화번호">
                            <b-form-row>
                                <b-form-input style="width: 400px;" v-model="bookingInfo.phoneNumber">

                                </b-form-input>

                            </b-form-row>
                        </b-form-group>

                        <b-form-group label-cols="2" horizontal label="요청사항">
                            <b-form-row>
                                <b-form-textarea :rows="5" :max-rows="5" style="width: 400px;" v-model="bookingInfo.wishComment" />
                            </b-form-row>
                        </b-form-group>

                        <b-modal id="callReservationCheck" ref="callReservationCheck" size="lg" title="예약내용확인" :hide-backdrop="false" :no-close-on-backdrop="true">
                            <call-reservation-check :bookingInfo="bookingInfo"></call-reservation-check>
                            <template slot="modal-footer">
                                <b-button variant="outline-primary" @click="hideModal" style="display:none">닫기</b-button>
                            </template>
                        </b-modal>

                        <b-form-group label-cols="7">
                            <b-form-row>
                                <b-button variant="primary" class="mt-4" style="width: 150px;" @click="showModal">예약접수</b-button>
                            </b-form-row>
                        </b-form-group>

                    </b-col>
                </b-row>
            </b-card>
        </b-colxx>

    </div>
</b-container>
</template>

<script>
import vSelect from 'vue-select'
import api from '../../constants/api'
import {
    mapGetters
} from "vuex";
import CallReservationCheck from "@/views/booking/components/CallReservationCheck";
import {
    alignTableCenter,
    eventBus,
    getDirection
} from "@/utils";

export default {
    props: {
        messsingText: String,
    },
    components: {
        'v-select': vSelect,
        'call-reservation-check': CallReservationCheck
    },
    computed: {
        ...mapGetters(["currentUser", "siteName", "brandInfo"]),
    },
    watch: {
        messsingText(val) {
            if (val !== undefined) {
                // this.messsingText = val;
                if (this.messsingText !== '') {
                    this.inputPh = val;
                    this.getPhoneNumberInfo();
                }
            }
            // console.log(val);
        },
        inventoryItem: function (val) {
            if (val != null) {
                this.selectTime(val);
            }
        },
        'bookingInfo.selectedStore'() {
            if (this.pageFlag2) {
                this.bookingInfo.reservationDate = null
                this.inventoryItem = null
                this.item = []
                this.pageChange()
            }

        },
    },

    data() {
        return {
            historyFieldsStr: [{
                    key: 'reservationDate',
                    label: "날짜",
                    ...alignTableCenter
                },
                {
                    key: 'reservationTime',
                    label: "시간",
                    ...alignTableCenter
                },
                {
                    key: 'headcount',
                    label: "인원",
                    ...alignTableCenter
                },
                // {key:'storeName', label: "방문매장", ...alignTableCenter},
                {
                    key: 'visitorRequests',
                    label: "요청사항",
                    ...alignTableCenter
                },
                {
                    key: 'bookingStatus',
                    label: "예약상태",
                    ...alignTableCenter
                },
                {
                    key: 'button',
                    label: "수정/삭제",
                    ...alignTableCenter
                },
            ],
            historyFields: [{
                    key: 'reservationDate',
                    label: "날짜",
                    ...alignTableCenter
                },
                {
                    key: 'reservationTime',
                    label: "시간",
                    ...alignTableCenter
                },
                {
                    key: 'headcount',
                    label: "인원",
                    ...alignTableCenter
                },
                {
                    key: 'storeName',
                    label: "방문매장",
                    ...alignTableCenter
                },
                {
                    key: 'visitorRequests',
                    label: "요청사항",
                    ...alignTableCenter
                },
                {
                    key: 'bookingStatus',
                    label: "예약상태",
                    ...alignTableCenter
                },
                {
                    key: 'button',
                    label: "수정/삭제",
                    ...alignTableCenter
                },
            ],

            storeList: [{
                label: '',
                value: null
            }], //예약가능 브랜드 매장리스트
            timeList: [], //예약가능 시간선택
            minDates: new Date(), //예약불가날짜(오늘이전)
            disableDates: [], //예약불가날짜
            item: [], //해당날짜에대한item
            inventoryItem: null, //선택한 시간대 예약정보
            minFlag: false,
            mintag: false, //60분 false 30분 true
            minDetailTag: false, //00분 false 30분 true
            headCountFlag: false,
            bookingInfo: {
                selectedStore: '', //브랜드관리자 : 선택한 스토어코드 , 스토어관리자 : 해당 스토어코드
                reservationDate: null, //예약할날짜
                reservationTime: '', //예약할시간
                adultCount: 0, //인원수 성인
                childCount: 0, //인원수 소인
                babyCount: 0, //인원수 유아
                guestName: '', //예약자명
                phoneNumber: '', //예약자 전화번호
                wishComment: '', //요청사항
                totalCount: 0,
                bookingNo: '', //업데이트경우 예약번호
                selectedStoreName: '',
                updateFlag: false,
                bookingListFlag: false,
            },
            listItem: [],
            fromDate: '',
            toDate: '',
            pageFlag: false,
            pageFlag2: false,
            searchHistory: false,
            searchPhoneNumber: '',
            searchName: '',
            visitCount: 0,
            searchHistoryList: [],
            inputPh: '',
            totalCancelCount: 0,
            totalNoShowCount: 0,
            totalVisitCount: 0,
            visitCountFor1Month: 0,
            test1: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
        }
    },
    mounted() {
        eventBus.$on('bus-event-phoneNumber', this.phoneNumber);
        // console.log(this.messsingText)
        if (this.messsingText !== '' && this.messsingText !== undefined) {
            this.inputPh = this.messsingText;
            console.log(this.inputPh)
            this.getPhoneNumberInfo();
        }else{
            this.inputPh = '';
        }
        document.body.classList.add('nopos');
        if (this.currentUser.userRole == 'BRAND_ADMIN') {
            this.setStoreList()
        }
        if (this.currentUser.userRole == 'STORE_MANAGER') {
            this.setStore()
        }
    },

    methods: {
        phoneNumber(val){
            if (val !== undefined) {
                if (this.messsingText !== '') {
                    this.inputPh = val;
                    this.getPhoneNumberInfo();
                }
            }
        },
        setStoreList() {
            const reqUrl = api.changeAPI(this.siteName, api.basicURL + api.shop.brandStoreCodeSearch)

            this.$http.get(reqUrl, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    res.data.data.forEach((value, index) => {
                        if (value.enabled) {
                            this.storeList.push({
                                value: value.storeCode,
                                label: value.storeName
                            })
                        }
                    })
                    this.bookingInfo.selectedStore = this.storeList[1].value
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);

            })
        },
        setStore() {
            const reqUrl = api.changeAPI(this.siteName, api.basicURL + api.shop.basicInfoStr)

            this.$http.get(reqUrl, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    const data = res.data.data

                    this.bookingInfo.selectedStore = data.storeCode
                    this.bookingInfo.selectedStoreName = res.data.data.basicInfo.storeName
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })
        },
        showModal() {
            this.bookingInfo.totalCount = Number(this.bookingInfo.adultCount) + Number(this.bookingInfo.childCount)
            if (this.bookingInfo.totalCount <= 0) {
                alert("예약인원을 선택해주세요")
                return false
            } else if (this.bookingInfo.guestName == '') {
                alert("예약자명을 입력해주세요")
                return false
            } else if (this.bookingInfo.phoneNumber == '' || this.bookingInfo.phoneNumber == null) {
                alert("전화번호를 입력해주세요.");
                return false
            } else {
                if (this.currentUser.userRole == 'BRAND_ADMIN') {

                    var reqUrl = api.changeAPI(this.siteName, api.basicURL + api.shop.basicInfo)
                    var params = {
                        storeCode: this.bookingInfo.selectedStore
                    }
                    this.$http.get(reqUrl, {
                        params: params,
                        headers: {
                            'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                        }
                    }).then(res => {
                        if (res.data.code === "OK") {
                            this.bookingInfo.selectedStoreName = res.data.data.basicInfo.storeName

                        } else {
                            throw 400
                        }

                    }).catch(err => {
                        alert(err.response.data.message);
                    })
                }
                this.$refs['callReservationCheck'].show();
            }
        },
        hideModal() {
            this.$refs['callReservationCheck'].hide();
        },
        onClickTime(val, event) {
            if (document.getElementsByClassName("red").length != 0) {
                document.getElementsByClassName("red")[0].classList.remove('red');
            }

            event.target.classList.add('red');

            this.bookingInfo.reservationTime = val;

        },
        bookingInventory() {

            var dateVal = this.$moment(this.bookingInfo.reservationDate).format('YYYY-MM-DD').toString()

            this.item = [];
            this.inventoryItem = null
            // this.bookingInfo.reservationTime = '';

            if (this.currentUser.userRole == 'STORE_MANAGER') {
                var reqUrl = api.changeAPI(this.siteName, api.basicURL + api.shop.inventorySettingFreeBookingStr)
                var params = {
                    date: dateVal
                }
            }
            if (this.currentUser.userRole == 'BRAND_ADMIN') {
                var reqUrl = api.changeAPI(this.siteName, api.basicURL + api.shop.inventorySettingFreeBooking)
                var params = {
                    date: dateVal,
                    storeCode: this.bookingInfo.selectedStore
                }
            }

            this.$http.post(reqUrl, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    if (res.data.data.bookingPaused) {
                        if (confirm("예약중지상태입니다. 진행하시겠습니까?")) {
                            this.item = res.data.data.inventories
                            this.item.forEach(val => {
                                val.showBookingTime = val.bookingTime.substr(0, 5)
                            })

                        } else {
                            this.bookingInfo.reservationDate = null
                        }
                    } else {
                        this.item = res.data.data.inventories
                        this.item.forEach(val => {
                            val.showBookingTime = val.bookingTime.substr(0, 5)
                        })

                        //수정으로 들어왔을했경우 값 셋팅
                        if (this.bookingInfo.updateFlag == true) {
                            this.bookingInfo.updateFlag
                            var hour = this.bookingInfo.reservationTime.substr(0, 2);
                            var min = this.bookingInfo.reservationTime.substr(3, 2)
                            var count = []
                            var small;
                            var big;
                            //같은 시간대만 저장
                            this.item.forEach(val => {
                                if (val.bookingTime.substr(0, 2) == hour) {
                                    count.push(val)
                                }
                            })
                            //1Hour 같은시간대가 1개라면 1시간단위
                            if (count.length == 1) {
                                this.inventoryItem = count[0]
                                if (min != "00") {
                                    this.minFlag = true;
                                }
                                //30Min 같은시간대가 2개라면 30분단위
                            } else {
                                if (min != "00" && min != "30") {
                                    this.minFlag = true;
                                }

                                this.mintag = true;
                                count.forEach(val => {
                                    if (val.bookingTime.substr(3, 2) < 30) {
                                        small = val
                                    } else {
                                        big = val
                                    }
                                })
                                if (min < 30) {
                                    //10,20분
                                    this.inventoryItem = small
                                } else {
                                    //40,50분
                                    this.inventoryItem = big
                                    this.minDetailTag = true
                                }

                            }

                        }

                    }
                } else {
                    throw 400
                }

            }).catch(err => {
                alert(err.response.data.message);
            })

        },
        pageChange(obj) {
            //달력의 페이지버튼을 눌렀를때
            if (obj != undefined) {
                if (obj.days == undefined) {
                    var year = (obj.year).toString()
                    var month = obj.month
                    var days = (obj.monthComps.days).toString()
                    month = month >= 10 ? month : '0' + month;

                    this.fromDate = year + "-" + month.toString() + "-" + "01"
                    this.toDate = year + "-" + month.toString() + "-" + days
                    if (this.currentUser.userRole == 'STORE_MANAGER') {
                        var reqUrl = api.changeAPI(this.siteName, api.basicURL + api.shop.inventorySettingFreeBookingListStr)
                        var params = {
                            from: this.fromDate,
                            to: this.toDate
                        }
                    }
                    if (this.currentUser.userRole == 'BRAND_ADMIN') {
                        var reqUrl = api.changeAPI(this.siteName, api.basicURL + api.shop.inventorySettingFreeBookingList)
                        var params = {
                            from: this.fromDate,
                            to: this.toDate,
                            storeCode: this.bookingInfo.selectedStore
                        }
                    }

                    this.$http.post(reqUrl, params, {
                        headers: {
                            'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                        }
                    }).then(res => {
                        if (res.data.code === "OK") {

                            this.disableDates = [];
                            res.data.data.dates.forEach(value => {
                                if (value.bookingUnavailable) {
                                    this.disableDates.push(value.date)
                                }
                            })

                        } else {
                            throw 400
                        }

                    }).catch(err => {
                        alert(err.response.data.message);
                    })

                }
                //달력의 페이지버튼을 누르지 않았지만 예약날짜를 알때(수정)
            } else if (this.bookingInfo.reservationDate != null) {
                var year = this.bookingInfo.reservationDate.substr(0, 4)
                var month = this.bookingInfo.reservationDate.substr(5, 2)
                var days = new Date(year, month, 0).getDate()

                this.fromDate = year.toString() + "-" + month.toString() + "-" + "01"
                this.toDate = year.toString() + "-" + month.toString() + "-" + days.toString()

                if (this.currentUser.userRole == 'STORE_MANAGER') {
                    var reqUrl = api.changeAPI(this.siteName, api.basicURL + api.shop.inventorySettingFreeBookingListStr)
                    var params = {
                        from: this.fromDate,
                        to: this.toDate
                    }
                }
                if (this.currentUser.userRole == 'BRAND_ADMIN') {
                    var reqUrl = api.changeAPI(this.siteName, api.basicURL + api.shop.inventorySettingFreeBookingList)
                    var params = {
                        from: this.fromDate,
                        to: this.toDate,
                        storeCode: this.bookingInfo.selectedStore
                    }
                }

                this.$http.post(reqUrl, params, {
                    headers: {
                        'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                    }
                }).then(res => {
                    if (res.data.code === "OK") {

                        this.disableDates = [];
                        res.data.data.dates.forEach(value => {
                            if (value.bookingUnavailable) {
                                this.disableDates.push(value.date)
                            }
                        })

                    } else {
                        throw 400
                    }

                }).catch(err => {
                    alert(err.response.data.message);
                })

            }
            //수정 x 클릭 x 오늘날짜기준
            else {

                var year = new Date().getFullYear()
                var month = new Date().getMonth() + 1
                var days = new Date(year, month, 0).getDate()
                month = month >= 10 ? month : '0' + month;

                this.fromDate = year.toString() + "-" + month.toString() + "-" + "01"
                this.toDate = year.toString() + "-" + month.toString() + "-" + days.toString()

                if (this.currentUser.userRole == 'STORE_MANAGER') {
                    var reqUrl = api.changeAPI(this.siteName, api.basicURL + api.shop.inventorySettingFreeBookingListStr)
                    var params = {
                        from: this.fromDate,
                        to: this.toDate
                    }
                }
                if (this.currentUser.userRole == 'BRAND_ADMIN') {
                    var reqUrl = api.changeAPI(this.siteName, api.basicURL + api.shop.inventorySettingFreeBookingList)
                    var params = {
                        from: this.fromDate,
                        to: this.toDate,
                        storeCode: this.bookingInfo.selectedStore
                    }
                }

                this.$http.post(reqUrl, params, {
                    headers: {
                        'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                    }
                }).then(res => {
                    if (res.data.code === "OK") {

                        this.disableDates = [];
                        res.data.data.dates.forEach(value => {
                            if (value.bookingUnavailable) {
                                this.disableDates.push(value.date)
                            }
                        })

                    } else {
                        throw 400
                    }

                }).catch(err => {
                    if (err.response.data.code == "INVALID_STATE") {
                        alert("선택하신 매장은 예약설정 정보가 없습니다\n예약 설정 후 다시 시도해주세요\n[매장관리 > 매장리스트 > 매장선택 > 예약설정]");
                    } else {
                        alert(err.response.data.message);
                    }
                })
            }
            this.pageFlag2 = true
        },
        getMinList() {
            this.minDetailTag = false
            this.mintag = false

            if (this.inventoryItem.timeUnit == 'M30') {
                this.mintag = true
                if (this.inventoryItem.bookingTime.substr(3, 2) == '30') {
                    this.minDetailTag = true
                }
            }

            if (this.minFlag == true) {
                this.minFlag = false
            } else {
                this.minFlag = true
            }

        },
        checkHeadCount() {
            this.bookingInfo.totalCount = Number(this.bookingInfo.adultCount) + Number(this.bookingInfo.childCount)
            if (this.inventoryItem == null) {
                alert("예약시간을 선택해주세요")
                this.bookingInfo.adultCount = 0
                this.bookingInfo.childCount = 0
                this.bookingInfo.totalCount = 0
            } else {

                if (this.inventoryItem.availableInventory < this.bookingInfo.totalCount) {
                    if (confirm("해당 시간대 예약 가능인원 정원이 초과되었습니다. 계속하시겠습니까?")) {

                    } else {
                        this.bookingInfo.adultCount = 0
                        this.bookingInfo.childCount = 0
                        this.bookingInfo.totalCount = 0

                    }
                }
            }

        },
        selectTime(val) {
            if (this.bookingInfo.updateFlag) {

            } else {
                var today = new Date();
                var hours = ('0' + today.getHours()).slice(-2);
                var minutes = ('0' + today.getMinutes()).slice(-2);
                var seconds = ('0' + today.getSeconds()).slice(-2);
                //현재시간
                var timeString = hours + ':' + minutes + ':' + seconds;
                //선택날짜
                var dateVal = this.$moment(this.bookingInfo.reservationDate).format('YYYY-MM-DD').toString()
                //현재날짜
                var todayDate = this.$moment(new Date()).format('YYYY-MM-DD').toString()

                if (dateVal == todayDate && val.bookingTime < timeString) {
                    alert("현재시간보다 이전시간을 선택할 수 없습니다.")
                    this.inventoryItem = null
                    return false;
                }
                this.headCountFlag = false
                this.bookingInfo.adultCount = 0
                this.bookingInfo.childCount = 0
                this.bookingInfo.totalCount = 0
                this.minFlag = false
                this.bookingInfo.reservationTime = val.bookingTime

                if (val.availableInventory < 1) {
                    if (confirm("해당 시간대 잔여가 0입니다. 계속하시겠습니까?")) {
                        this.bookingInfo.reservationTime = val.bookingTime
                        this.headCountFlag = true
                    } else {
                        this.inventoryItem = null
                        this.bookingInfo.reservationTime = null
                    }
                }

            }

            this.bookingInfo.updateFlag = false

            // if(val.availableInventory < 1){
            //   if(confirm("해당 시간대 잔여가 0입니다. 계속하시겠습니까?")){
            //     this.bookingInfo.reservationTime = val.bookingTime
            //   }else{
            //     this.inventoryItem = null
            //     this.bookingInfo.reservationTime = null
            //   }
            // }

        },
        createBooking() {
            this.bookingInfo.phoneNumber = this.searchPhoneNumber
            this.bookingInfo.guestName = this.searchName
            this.pageFlag = false;
            this.pageFlag = true;
        },
        getPhoneNumberInfo() {
            this.searchPhoneNumber = this.inputPh

            this.searchHistoryList = []
            this.totalCancelCount = 0
            this.totalNoShowCount = 0
            this.totalVisitCount = 0
            this.visitCountFor1Month = 0

            if (this.searchPhoneNumber == '') {
                alert("전화번호입력은 필수입니다.");
                this.searchPhoneNumber = ''
                this.searchName = ''
                this.searchHistory = false
                this.bookingInfo.bookingListFlag = false
                return false;
            }

            if (this.currentUser.userRole == 'STORE_MANAGER') {
                var reqUrl = api.changeAPI(this.siteName, api.basicURL + api.order.freeBookingsListStr)
                var params = {
                    phoneNumber: this.searchPhoneNumber
                }
            }
            if (this.currentUser.userRole == 'BRAND_ADMIN') {
                var reqUrl = api.changeAPI(this.siteName, api.basicURL + api.order.freeBookingsList)
                var params = {
                    storeCode: "",
                    phoneNumber: this.searchPhoneNumber
                }
            }

            this.$http.post(reqUrl, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    if (res.data.data.bookings[0] != null) {
                        this.searchHistoryList = res.data.data.bookings
                        this.searchName = res.data.data.bookings[0].visitorName
                        this.totalCancelCount = res.data.data.stats.totalCancelCount
                        this.totalNoShowCount = res.data.data.stats.totalNoShowCount
                        this.totalVisitCount = res.data.data.stats.totalVisitCount
                        this.visitCountFor1Month = res.data.data.stats.visitCountFor1Month
                        this.bookingInfo.bookingListFlag = true;
                        // console.log(this.searchHistoryList[0].reservationTime)
                        // console.log(this.searchHistoryList)
                    } else {
                        this.searchName = "NULL"
                    }
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })
            this.searchHistory = true;

        },
        deleteListBooking(val) {

            var reqUrl = api.changeAPI(this.siteName, api.basicURL + api.order.brdcancelBooking)
            var params = {
                bookingNo: val,
                noPenalty: false,
                memo: '',
            }

            if (confirm("예약을 취소처리 하시겠습니까?")) {
                this.$http.post(reqUrl, params, {
                    headers: {
                        'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                    }
                }).then(res => {
                    if (res.data.code === "OK") {
                        this.getPhoneNumberInfo()

                    } else {
                        throw 400
                    }
                }).catch(err => {
                    alert(err.response.data.message);
                })

            }

        },
        updateListBooking(val) {
            this.bookingInfo.bookingNo = val.bookingNo
            this.bookingInfo.selectedStore = val.storeCode
            this.bookingInfo.guestName = val.visitorName
            this.bookingInfo.phoneNumber = val.visitorPhone
            this.bookingInfo.reservationDate = val.reservationDate
            this.bookingInfo.wishComment = val.visitorRequests
            this.bookingInfo.adultCount = val.adultHeadcount
            this.bookingInfo.childCount = val.childHeadcount
            this.bookingInfo.babyCount = val.babyHeadcount
            this.bookingInfo.reservationTime = val.reservationTime

            this.bookingInfo.updateFlag = true;
            this.pageFlag = true;

        },
        rowClass(item) {
            if (item != null) {
                if (!item.cancellable && !item.changeable) {
                    return 'table-active'
                }
            }

        },
        checkAdultHeadCount(size) {
            this.bookingInfo.adultCount = size

            this.bookingInfo.totalCount = Number(this.bookingInfo.adultCount) + Number(this.bookingInfo.childCount)
            if (this.inventoryItem == null) {
                alert("예약시간을 선택해주세요")
                this.bookingInfo.adultCount = 0
                this.bookingInfo.childCount = 0
                this.bookingInfo.totalCount = 0
            } else {

                if (this.headCountFlag == false) {
                    if (this.inventoryItem.availableInventory < this.bookingInfo.totalCount) {
                        if (confirm("해당 시간대 예약 가능인원 정원이 초과되었습니다. 계속하시겠습니까?")) {

                        } else {
                            this.bookingInfo.adultCount = 0
                            this.bookingInfo.childCount = 0
                            this.bookingInfo.totalCount = 0

                        }
                    }
                }
            }

        },
        checkChildHeadCount(size) {
            this.bookingInfo.childCount = size

            this.bookingInfo.totalCount = Number(this.bookingInfo.adultCount) + Number(this.bookingInfo.childCount)
            if (this.inventoryItem == null) {
                alert("예약시간을 선택해주세요")
                this.bookingInfo.adultCount = 0
                this.bookingInfo.childCount = 0
                this.bookingInfo.totalCount = 0
            } else {

                if (this.headCountFlag == false) {
                    if (this.inventoryItem.availableInventory < this.bookingInfo.totalCount) {
                        if (confirm("해당 시간대 예약 가능인원 정원이 초과되었습니다. 계속하시겠습니까?")) {

                        } else {
                            this.bookingInfo.adultCount = 0
                            this.bookingInfo.childCount = 0
                            this.bookingInfo.totalCount = 0

                        }
                    }
                }
            }

        },
        checkBabyHeadCount(size) {
            this.bookingInfo.babyCount = size

        },

    },

}
</script>

<style scoped>
body.nopos .tooltip {
    top: -146px !important;
}

.red {
    background: #dc3545 !important;
    color: #fff !important;

}

.vertical-line {
    border-left: 1px solid;
    color: lightgrey;
}

body.ltr.rounded.nopos.modal-open .tooltip {
    top: 0 !important;
}

.vitext {
    font-size: 20px;
    font-weight: 600;
    width: 100%;
    text-align: center;
}

a.vitextA {
    width: 100%;
    text-align: center;
    display: block;
}

.textgreen {
    color: blue !important;
}

.d-inline-block {
    width: 100%;
    max-height: 470px;
    overflow-y: auto;
}

</style>
